
<div mat-dialog-title>Edit Multiple Securities<button class="close" mat-button title="Cancel" (click)="close()"><i class="material-icons clear">clear</i></button></div>
<mat-dialog-content>
  <div>
    <div style="margin-bottom: 10px;"><strong>Securities: {{securities.length}} selected</strong></div>
    <p>These securities' settings will be impacted by your edit:</p>
  </div>
  <div>
    <table width="100%">
      <tr>
        <td style="vertical-align: top; width: 72px; padding: 10px 0;"><strong>Securities</strong></td>
        <td style="padding: 10px;">
          <div id="selectedPortfolios"
            style="overflow-y: auto;width: 100%; min-height: 60px; max-height: 210px; border: 1px solid #CFCFCF; padding: 5px; background-color: #FFFFFF;">
            @if (securities && securities?.length > 0) {
              <table id="selectedEditPortfolios" style="width:100%;"
                >
                @for (security of securities; track security) {
                  <tr>
                    <td style="max-width:90px; white-space:nowrap; text-overflow: ellipsis;">
                    {{security.securitySymbol}}</td>
                    <td style="max-width: 410px;white-space:nowrap; text-overflow: ellipsis;">{{security.securityDescription}}
                    </td>
                  </tr>
                }
              </table>
            }
          </div>
        </td>
      </tr>
    </table>
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  <button id="closeButton" (click)="close()" class="btn-medium-secondary">Cancel</button>
  <button class="btn-medium-primary green" (click)="editSelectedSecurities()">Continue</button>
</mat-dialog-actions>
